'use strict'

module.exports = {
  checkStringParam: require('./check-string-param.js')
, has: require('./has.js')
, isValidTimestamp: require('./is-valid-timestamp.js')
}
